import { NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@NgModule({
  imports: [MatIconModule],
})
export class IconsModule {
  private pathIcons = './assets/img/icons';

  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry,
  ) {
    this.registerIconsNamespace();
  }

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private registerIconsNamespace(): void {
    const namespace = 'icons';
    this.matIconRegistry
      .addSvgIconInNamespace(
        namespace,
        'filter',
        this.setPath(`${this.pathIcons}/filter.svg`),
      )
      .addSvgIconInNamespace(
        namespace,
        'filter-selected',
        this.setPath(`${this.pathIcons}/filter-selected.svg`),
      );
  }
}
